/** @jsxImportSource @emotion/react */
import { HTMLSelect } from "@blueprintjs/core"
import { useEffect } from "react"
import { FlexContainer } from "../../../../../styled/flexbox.styled"
import { ScientTradingAccount, TradingBook } from "../../types"
import { useController, UseControllerProps } from "react-hook-form"
import { WaveInputs } from "../types/form"

interface AccountBookSelectProps extends UseControllerProps<WaveInputs> {
  options: (ScientTradingAccount | TradingBook)[]
  disabled?: boolean
}

const AccountBookSelect = ({ control, name, rules, options, disabled }: AccountBookSelectProps) => {
  const { field } = useController({ control, name, rules })

  // Auto-select on initial mount or when current value becomes invalid
  useEffect(() => {
    if (!options || options.length === 0) return

    const hasCurrentSelection = field.value != null && options.some(o => o.id === field.value)
    if (hasCurrentSelection) return

    const nextSelection = options.find(o => o.is_default) ?? options[0]
    if (nextSelection && nextSelection.id !== field.value) {
      field.onChange(nextSelection.id)
    }
  }, [options, field])

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const raw = event.target.value
    const parsed = raw === "" ? undefined : parseInt(raw)
    field.onChange(parsed)
  }

  return (
    <FlexContainer gap="22px" alignItems="center">
      <FlexContainer gap="5px" flexDirection="column">
        <HTMLSelect
          value={field.value || ""}
          options={options.map(o => ({
            label: "code" in o ? o.code : o.name,
            value: o.id,
          }))}
          onChange={handleChange}
          disabled={disabled}
        />
      </FlexContainer>
    </FlexContainer>
  )
}

export default AccountBookSelect
